module.exports = __webpack_public_path__ + "static/media/rating_information1.e11c1c49.png";